import { memo, useEffect } from 'react'

export default memo(({ navigate, to }) => {

  useEffect(() => {
    const type = localStorage.getItem('type');
    if (type === 'doctor') {
      setTimeout(() => navigate('/associados', to, { replace: true }), 0);
    } else if (type === 'establishment') {
      setTimeout(() => navigate('/estabelecimento/dashboard', to, { replace: true }), 0)
    } else if (type === "operator") {
      setTimeout(() => navigate('/relatorios', to, { replace: true }), 0)
    } else {
      setTimeout(() => navigate('/arquivos', to, { replace: true }), 0)
    }
  }, [navigate, to])

  return null
})
